import Vue from 'vue'
import Vuex from 'vuex'
import api from '../api/api.js'

Vue.use(Vuex)
const store = new Vuex.Store({
    state: {
        JWT: '', // jwt登录
        userStatus: {}, // 用户信息
        errorMessage: '', // 错误提示信息
    },
    mutations: {
        getJWT(state, jwt) {
            state.JWT = jwt;
        },
		loginUserInfo (state, guideData) {
			state.userStatus = guideData.value
        },
		changeErrorMessage (state, guideData) {
			state.errorMessage = guideData.value
		},
    },
    actions: {
        /**
         * 获取用户登录状态及信息
         * @param {*} context 
         */
		getLoginUserInfo (context) {
			const data = {
	          version: Math.random()
	      	}
            api.loginStatus(data).then(res=>{
                if(res.status == 200) {
                    context.commit('loginUserInfo', {
                        value: res.data
                    })
                }
            }).catch(res=>{

            })
        },
    }
})
export default store


// WEBPACK FOOTER //
// ./src/store/index.js